module.exports = __webpack_public_path__ + "static/media/scooter-big.26612629.png";